import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { IAnnualReportTemplateDTO, IAnnualReportTemplateNotesTypesTableData } from '@modeso/aumico-lib-annualreport-fe';
import { EMPTY_ARRAY_LENGTH, ITableOptions } from '@modeso/aumico-lib-core-fe';
import { GetNotesTypesNamesAndIdsDTO } from '@modeso/types__aumico-lib-notes-be';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BehaviorSubject } from 'rxjs';

@UntilDestroy()
@Component({
    selector: 'aumico-lib-ar-template-notes-page',
    templateUrl: './ar-template-notes.page.html',
    styleUrls: ['./ar-template-notes.page.scss'],
})
export class ArTemplateNotesPageComponent implements OnChanges {
    public disableProceedButton = true;
    public currentAnnualReportTemplate: IAnnualReportTemplateDTO | undefined;
    public options: ITableOptions | undefined;
    public tableData: IAnnualReportTemplateNotesTypesTableData[] = [];
    public searchValue: string | undefined;
    public dataSource = new MatTableDataSource<any>(this.tableData);

    @Input() filterSubject?: BehaviorSubject<string>;
    @Input() selectedNotesTypes: GetNotesTypesNamesAndIdsDTO[] = [];
    @Input() notesTypesList: GetNotesTypesNamesAndIdsDTO[] = [];

    @Output() selectedNotesTypesChanged = new EventEmitter<GetNotesTypesNamesAndIdsDTO[]>();

    ngOnChanges(changes: SimpleChanges): void {
        if (
            changes['notesTypesList'] != null &&
            this.notesTypesList.length > EMPTY_ARRAY_LENGTH &&
            this.selectedNotesTypes.length === EMPTY_ARRAY_LENGTH
        ) {
            this.tableData = [];
            this.notesTypesList.forEach((notesType) => {
                this.tableData.push({
                    _id: notesType._id,
                    name: notesType.name,
                    selected: false,
                });
            });
        }

        if (
            changes['selectedNotesTypes'] != null &&
            this.selectedNotesTypes.length > EMPTY_ARRAY_LENGTH &&
            this.notesTypesList.length > EMPTY_ARRAY_LENGTH
        ) {
            this.handleSavedOrderOfTableData();

            this.notesTypesList.forEach((data) => {
                if (
                    this.selectedNotesTypes.some(
                        (notesType) => notesType._id === data._id && notesType.name === data.name,
                    )
                ) {
                    const selectedRowIndex = this.tableData.findIndex((item) => item._id === data._id);
                    this.handleSelection(this.tableData[selectedRowIndex]);
                }
            });
        }
    }

    public applyFilter(value): void {
        this.searchValue = value;
    }

    private handleSavedOrderOfTableData(): void {
        this.tableData = this.selectedNotesTypes.slice();
        this.notesTypesList.forEach((data) => {
            if (!this.tableData.some((item) => item._id === data._id)) {
                this.tableData.push(data);
            }
        });
    }

    public drop(event: CdkDragDrop<string[]>): void {
        moveItemInArray(this.tableData, event.previousIndex, event.currentIndex);
        this.emitSelectedNotesTypesInOrder();
    }

    public handleSelection(row: IAnnualReportTemplateNotesTypesTableData): void {
        row.selected == null ? (row.selected = true) : (row.selected = !row.selected);
        this.emitSelectedNotesTypesInOrder();
    }

    public emitSelectedNotesTypesInOrder(): void {
        const selectedRowsInOrder: GetNotesTypesNamesAndIdsDTO[] = [];

        for (const data of this.tableData) {
            if (data.selected) {
                selectedRowsInOrder.push(data);
            }
        }

        this.selectedNotesTypesChanged.emit(selectedRowsInOrder);
    }
}
